<h1>{{ 'support.title' | translate }}</h1>

<div [nbSpinner]="loading()"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">

  @if(!loading()) {
    <nb-tabset class="centered-tabs" (changeTab)="onTabChange()">
      <nb-tab [tabTitle]="'support.english' | translate" tabId="uk">
        <app-video-player [tabChanged]="tabChanged" [videos]="videos()" languageCode="en"></app-video-player>
      </nb-tab>
      <nb-tab [tabTitle]="'support.french' | translate" tabId="fr">
        <app-video-player [tabChanged]="tabChanged" [videos]="videos()" languageCode="fr"></app-video-player>
      </nb-tab>
    </nb-tabset>
  }

</div>
